import { useEffect, useState } from "react";

export const useDebouncedLoading = ({
  isLoading,
  delay = 100,
}: {
  isLoading: boolean;
  delay?: number;
}) => {
  const [debouncedLoading, setDebouncedLoading] = useState(false);

  useEffect(() => {
    let timerId: NodeJS.Timeout | undefined;

    if (isLoading) {
      timerId = setTimeout(() => {
        setDebouncedLoading(true);
      }, delay);
    } else {
      setDebouncedLoading(false);
    }
    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [isLoading, delay]);

  return debouncedLoading;
};
